/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Quotas_Save_Changes_IdleInputs */



/**
* | output |
* | --- |
* | "Save changes" |
*
* @param {Sub_Quotas_Save_Changes_IdleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_save_changes_idle = /** @type {((inputs?: Sub_Quotas_Save_Changes_IdleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Save_Changes_IdleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderungen speichern")
	return /** @type {LocalizedString} */ ("Save changes")
});